// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/factors-affecting-stall-speed.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/factors-affecting-stall-speed/factors-affecting-stall-speed.js';

mount([g0]);
